// extracted by mini-css-extract-plugin
module.exports = {"gwCpEditCoveragesButton":"CoverageSummary_gwCpEditCoveragesButton__3Y_0r","editCoverageButton":"CoverageSummary_editCoverageButton__eXcZt"};